import { render, staticRenderFns } from "./AmountText.vue?vue&type=template&id=2bb960cb&scoped=true"
import script from "./AmountText.vue?vue&type=script&lang=js"
export * from "./AmountText.vue?vue&type=script&lang=js"
import style0 from "./AmountText.vue?vue&type=style&index=0&id=2bb960cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb960cb",
  null
  
)

export default component.exports